/**
 * Connections: an organization's link to a system that sends or receives data, whatever carries
 * it. The transport-specific settings hang off a connection, so these are the parts every
 * transport shares.
 */
import { z } from 'zod';
/** How a connection is doing overall, whatever its transport. */
export var ConnectionState;
(function (ConnectionState) {
    ConnectionState["Active"] = "Active";
    ConnectionState["Inactive"] = "Inactive";
    ConnectionState["Error"] = "Error";
})(ConnectionState || (ConnectionState = {}));
/** What moves the bytes, and so which transport's settings apply. */
export var ConnectionTransportType;
(function (ConnectionTransportType) {
    ConnectionTransportType["Sftp"] = "sftp";
    ConnectionTransportType["RestApi"] = "rest-api";
    ConnectionTransportType["Mllp"] = "mllp";
})(ConnectionTransportType || (ConnectionTransportType = {}));
/** Query parameters `GET /connections` accepts. */
export const ConnectionListQuerySchema = z.object({
    organizationId: z
        .uuid()
        .describe('Return only connections of this organization, within what the caller may see.')
        .optional(),
    transportType: z
        .enum(ConnectionTransportType)
        .describe('Return only connections over this transport.')
        .optional(),
});
/**
 * Body `PATCH /connections/{id}` accepts: what any connection is described by. The transport is
 * not among it, since the settings a connection carries depend on it.
 */
export const ConnectionUpdateBodySchema = z.object({
    name: z.string().optional(),
    description: z.string().nullable().optional(),
    state: z.enum(ConnectionState).optional(),
});
/** Query parameters `GET /connections/{id}/resources` accepts. */
export const ConnectionResourceListQuerySchema = z.object({
    resourceKey: z.string().describe('Which kind of resource to list.'),
    limit: z.coerce
        .number()
        .min(1)
        .max(100)
        .default(25)
        .describe('How many resources to return.'),
    offset: z.coerce
        .number()
        .min(0)
        .default(0)
        .describe('How many to skip, for paging.'),
});
//# sourceMappingURL=connection.js.map